const o = {}, t = {
  dropdownListItem: o
};
export {
  t as dropdownsTheme
};
